import { render, staticRenderFns } from "./surplus.vue?vue&type=template&id=52635394&scoped=true&"
import script from "./surplus.vue?vue&type=script&lang=js&"
export * from "./surplus.vue?vue&type=script&lang=js&"
import style0 from "./surplus.vue?vue&type=style&index=0&id=52635394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52635394",
  null
  
)

export default component.exports